import { useOutletContext } from "react-router-dom";
import { FeeManager } from "@dealer-center/core-feemanager-react";
import type { ControlcenterAPIInterfaceExternal } from "@dealer-center/ddc-pages-controlcenter-interface";

export const DdcFeeManager = () => {
  const { ccUserInfo } = useOutletContext<{
    ccUserInfo: ControlcenterAPIInterfaceExternal;
  }>();

  const tenantId = ccUserInfo?.accountId ?? "";
  const tenantUser = ccUserInfo?.internalUserId ?? ccUserInfo?.userId ?? "";

  // ccUserInfo absence (misconfigured route) denies access.
  // Both accountPermissions and userPermissions must include INVENTORY.FEEMANAGER.
  const hasAccess =
    !!ccUserInfo &&
    tenantId.toLowerCase() !== "ddc" &&
    ccUserInfo.accountPermissions.includes("INVENTORY.FEEMANAGER") &&
    ccUserInfo.userPermissions.includes("INVENTORY.FEEMANAGER");

  return (
    <FeeManager
      basePath="/landing/nxlambda/feeManager"
      clientId="dealercenter"
      hasAccess={hasAccess}
      tenantId={tenantId}
      tenantType="DDC"
      tenantUser={tenantUser}
    />
  );
};
